import React, { useEffect, useState } from 'react';
import { FormControl, Grid, InputLabel, OutlinedInput, FormHelperText } from '@material-ui/core';
import { useLayoutContext } from '../../Context/Layout.context';
import { authUserEmail } from '../../services/users/users.service';
import { useStyles } from './EditUserPhone.styles';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';
import { validateFormatEmailInput } from '../../services/validation/validationUser';
import { useHistory } from 'react-router-dom';
import { Paths } from '../../utils/routerUrls';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';

interface AuthUserEmailProps {
  open: boolean;
  userId: string;
  onEmailConfirmed: () => void;
}

export const AuthUserEmail: React.FC<AuthUserEmailProps> = (props) => {
  const classes = useStyles();
  const history = useHistory();

  const [email, setEmail] = useState<string>('');
  const [validEmail, setValidEmail] = useState<boolean>(true);
  const [uniqueEmail, setUniqueEmail] = useState<boolean>(true);
  const [newEmailErrorMessage, setNewEmailErrorMessage] = useState<string>('');
  const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState<boolean>(true);
  const [newInput, setIsNewInput] = useState<boolean>(false);

  const { openAlert, showLoader } = useLayoutContext();

  useDocumentTitle('Nie pamiętasz hasła?');
  const handleAuthUserEmail = () => {
    showLoader(true, 'Weryfikuję dane');
    if (email) {
      authUserEmail(email)
        .then(
          () => {
            props.onEmailConfirmed();
          },
          () => {
            if (navigator.onLine) {
              setValidEmail(false);
              openAlert('error');
            } else {
              openAlert('error', 'W wyniku braku połączenia z internetem zapisywanie danych nie powiodło się.');
            }
          },
        )
        .finally(() => {
          showLoader(false);
        });
    }
  };

  useEffect(() => {
    if (email !== '') {
      setValidEmail(true);
      setUniqueEmail(true);
      setNewEmailErrorMessage('');
      setIsUpdateButtonDisabled(false);
    } else {
      setIsUpdateButtonDisabled(true);
    }
  }, [email]);

  useEffect(() => {
    if (newInput) {
      setIsUpdateButtonDisabled(false);
    } else if (newEmailErrorMessage !== '') {
      setIsUpdateButtonDisabled(true);
    } else setIsUpdateButtonDisabled(true);
  }, [newInput, newEmailErrorMessage]);

  const handleChangeNewEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setIsNewInput(true);
  };

  const handleVerifyUserMail = () => {
    const hasValidEmailFormat = validateFormatEmailInput(email);
    if (hasValidEmailFormat) {
      setValidEmail(true);
      handleAuthUserEmail();
    } else {
      setValidEmail(false);
      setNewEmailErrorMessage('Podany e-mail jest nieprawidłowy');
    }
  };

  window.addEventListener("keyup", (e) => {
   if(e.key === 'Escape') {
    history.push('/')
   }
  });

  return (
    <>
      <ModalWithButtons
        open={props.open}
        size="sm"
        navButtonLabel="Powrót do logowania"
        handleNavBack={() => history.push('/')}
        title={null}
        autoHeight={true}
        onConfirm={() => handleVerifyUserMail()}
        confirmButtonLabel="Wyślij"
        confirmButtonDisabled={isUpdateButtonDisabled || newEmailErrorMessage !== ''}
        buttonsContainerStyle={{ marginTop: '40px' }}
        isHideBackdrop={true}
      >
        <Grid container className={classes.container}>
          <Grid>
            <h1 className={classes.modalSubTitle}>Nie pamiętasz hasła?</h1>
          </Grid>
          <Grid>
            <div className={classes.modalText}>
              Podaj adres E-mail na który zostanie wysłany link aktywacyjny do zmiany hasła
            </div>
          </Grid>

          <Grid item xs={12} className={classes.item}>
            <FormControl variant="outlined">
              <InputLabel
                style={{
                  color: !uniqueEmail || !validEmail ? '#BC0000' : '#2C2D3E',
                }}
                htmlFor="new-email"
              >
                E-mail
              </InputLabel>
              <OutlinedInput
                id="new-email"
                value={email}
                onChange={handleChangeNewEmail}
                fullWidth={true}
                error={!uniqueEmail || !validEmail}
                inputProps={{
                  style: {
                    width: '255px',
                    padding: '15.5px',
                    color: '#2C2D3E',
                    borderColor: !uniqueEmail || !validEmail ? '#BC0000' : '#2C2D3E',
                  },
                }}
                label="E-mail*"
              />
              <FormHelperText
                className={classes.errorMessagesContainer}
                error
                id="new-email-error"
                data-testid="new-email-error"
                component={'div'}
                aria-label="Nieprawidłowy email"
              >
                {newEmailErrorMessage && <div aria-label="Nieprawidłowy email" className={classes.errorMessage}>{newEmailErrorMessage}</div>}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </ModalWithButtons>
    </>
  );
};
